import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {AppAlertGqlModel, AppAlertInputGqlModel} from "./app-alert.gql-model";
import {Apollo} from "apollo-angular";
import {map} from "rxjs/operators";
import {SuccessResultGqlModel} from "../graphql/common.gql-model";

@Injectable()
export class AppAlertService {
  currentAlerts: AppAlertGqlModel[] = [];
  alerts: BehaviorSubject<AppAlertGqlModel[]> = new BehaviorSubject<AppAlertGqlModel[]>([]);

  saveGeneralAlert(alert: AppAlertGqlModel): Promise<SuccessResultGqlModel> {
    const model = new AppAlertInputGqlModel({alert});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(AppAlertInputGqlModel.mapper)
      .toPromise();
  }

  removeGeneralAlert(alert: AppAlertGqlModel): Promise<SuccessResultGqlModel> {
    const model = new AppAlertInputGqlModel({alert, remove: true});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(AppAlertInputGqlModel.mapper)
      .toPromise();
  }

  constructor(private apollo: Apollo) {
    this.apollo.subscribe({query: AppAlertGqlModel.query, fetchPolicy: "no-cache"})
      .pipe(
        AppAlertGqlModel.mapper,
        map(alerts => alerts.sort((a, b) => a.priority - b.priority)),
      )
      .subscribe(this.alerts);

    this.alerts.subscribe((alerts) => {
      this.currentAlerts = alerts;
    });
  }
}
